import { render, staticRenderFns } from "./StudentRecord.vue?vue&type=template&id=0975aa2b&scoped=true"
import script from "./StudentRecord.vue?vue&type=script&lang=ts"
export * from "./StudentRecord.vue?vue&type=script&lang=ts"
import style0 from "./StudentRecord.vue?vue&type=style&index=0&id=0975aa2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975aa2b",
  null
  
)

export default component.exports